import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
};

export default registry;
